import { Card, Typography, CardContent, CardActions, Button } from "@mui/material";
import { useGetUser } from "hooks/useGetUser";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaSignOutAlt, FaWindows } from "react-icons/fa";

export const SelectOrg = () => {
  const navigate = useNavigate();
  const { data: user, isLoading, refetch } = useGetUser();
  console.log("user:", user);

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (user) {
      // Если пользователь имеет только одну организацию, то перенаправляем на главную страницу, в противном случае даем возможность выбрать организацию
      if (user.members && user.members.length === 1) {
        localStorage.setItem("orgID", user.members[0].orgID);
        window.location.href = "/admin/inbox";
      }
    }
  }, [user]);

  const selectOrg = (orgID: string) => {
    localStorage.setItem("orgID", orgID);
    window.location.href = "/admin/inbox";
  };

  if (isLoading) {
    return <div>Загрузка...</div>;
  }

  return (
    <div className="flex flex-col gap-4 md:w-1/2 mx-auto">
      <h1 className="text-2xl font-bold">Пожалуйста, выберите организацию</h1>
      <Card>
        <CardContent>
          {user.members &&
            user.members.map((member: any, index: number) => (
              <div key={member.id}>
                <div
                  className="flex gap-4 items-center py-2"
                  onClick={() => selectOrg(member.orgID)}
                >
                  <div className="w-[80px] h-[80px]">
                    <img
                      src={member.org.logo}
                      alt={member.org.name}
                      className="w-100 h-100 object-contain"
                    />
                  </div>
                  <div className="text-lg font-bold text-blue-500 hover:text-blue-700 cursor-pointer">
                    {member.org.name}
                  </div>
                </div>
                {index !== user.members.length - 1 && (
                  <div className="border-b border-gray-300 w-full"></div>
                )}
              </div>
            ))}
        </CardContent>
        <CardActions>
          <div className="w-full p-8">
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              onClick={() => navigate("/auth/logout")}
              className="flex items-center gap-2"
            >
              <FaSignOutAlt />
              Выйти
            </Button>
          </div>
        </CardActions>
      </Card>
    </div>
  );
};
